export default "__VITE_ASSET__5af2c1da__"